import { IUser, IUserOrganization } from '../../utils/interfaces';

class UserModel implements IUser {
  id: string;
  firstName: string;
  lastName: string;
  documentNumber?: string;
  phoneNumber?: string;
  email: string;

  constructor(data: IUser) {
    this.id = data.id;
    this.firstName = data.firstName;
    this.lastName = data.lastName;
    this.documentNumber = data.documentNumber;
    this.phoneNumber = data.phoneNumber;
    this.email = data.email;
  }
}

export default UserModel;

export class UserOrganizationModal implements IUserOrganization {
  id: string;
  name?: string;

  constructor(data: IUserOrganization) {
    this.id = data.id;
    this.name = data.name;
  }
}
